import { Injectable } from '@angular/core';

import { Customer } from '@models';
import { CrudService, HttpService } from '@services';

@Injectable({ providedIn: 'root' })
export class CustomerService extends CrudService<Customer> {
  constructor(http: HttpService) {
    super('customer', http);
  }

  public async updateImage(file: File, customer: Customer): Promise<Customer> {
    const res = await this.http.postWithFile<Customer>(
      `${this.url}/${customer.id}/image`,
      {},
      file
    );
    return res.data;
  }

  override create(item: Customer): Promise<Customer> {
    throw new Error('cannot create customers');
  }

  override delete(id: string): Promise<string> {
    throw new Error('cannot delete customers');
  }
}
